import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const SmartLeadProcessor = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default SmartLeadProcessor